var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlShopBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 183.1 189.2",
    style: {
      enableBackground: "new 0 0 183.1 189.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M148,46.3c-0.1-2.1-1.9-3.8-4-3.8h-24.5v-0.9c0.1-1.8,0.6-17.1-8.5-26.8c-4.8-5.1-11.3-7.7-19.3-7.7C83,7.2,76,10,71.1,15.5 c-8.6,9.6-7.7,24.2-7.5,26.3v0.8H39.1c-2.1,0-3.9,1.6-4,3.8l-8,131.4c-0.1,1.1,0.3,2.2,1.1,3s1.8,1.3,2.9,1.3H152 c1.1,0,2.2-0.5,2.9-1.3s1.1-1.9,1.1-3L148,46.3z M71.6,41.2c0-0.1-1.3-12.9,5.5-20.4c3.3-3.7,8.3-5.6,14.6-5.6 c5.8,0,10.2,1.7,13.5,5.2c7.1,7.5,6.3,20.8,6.3,21c0,0.1,0,0.2,0,0.3v1H71.6v-1C71.6,41.5,71.6,41.3,71.6,41.2z M35.3,174l7.5-123.4 h20.8v8.6c-2.5,1.3-4.2,4-4.2,7c0,4.4,3.5,7.9,7.9,7.9s7.9-3.5,7.9-7.9c0-2.8-1.5-5.3-3.6-6.7v-9h39.9v8.9c-2.3,1.4-3.8,3.9-3.8,6.8 c0,4.4,3.5,7.9,7.9,7.9s7.9-3.5,7.9-7.9c0-2.9-1.6-5.5-4-6.9v-8.8h20.7l7.5,123.4H35.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlShopBag);
export default __webpack_public_path__ + "static/media/PL-ShopBag.15c18b8ff803d1047f549e235408975d.svg";
export { ForwardRef as ReactComponent };